var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIllustrationCustomDocker = function SvgIllustrationCustomDocker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 160,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-custom-docker_svg__a)",
    fillRule: "evenodd",
    d: "M300 27H0v-1h300z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5C0C0",
    fillOpacity: 0.2,
    d: "M124 66.667c0-2.025 1.791-3.667 4-3.667h43c2.209 0 4 1.642 4 3.667V74h-51z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5C0C0",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M171 64h-43a3 3 0 0 0-3 3v7h49v-7a3 3 0 0 0-3-3m-43-1a4 4 0 0 0-4 4v8h51v-8a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5C0C0",
    fillRule: "evenodd",
    d: "M142 27v36h-1V27zM157 27v36h-1V27z",
    clipRule: "evenodd",
    opacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5C0C0",
    fillOpacity: 0.8,
    fillRule: "evenodd",
    d: "M200 75H100v-1h100zm0 31H100v1h100z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5C0C0",
    fillOpacity: 0.1,
    d: "M128 106h-28V75h28z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-custom-docker_svg__b)",
    fillRule: "evenodd",
    d: "M108 75h-4v31h4zm8 0h-4v31h4zm4 0h4v31h-4zm12 0h-4v31h4zm4 0h4v31h-4zm12 0h-4v31h4zm4 0h4v31h-4zm12 0h-4v31h4zm4 0h4v31h-4zm12 0h-4v31h4zm4 0h4v31h-4zm12 0h-4v31h4z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-custom-docker_svg__c)",
    d: "M89.238 123h121.524L260 153H40z",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5C0C0",
    fillOpacity: 0.08,
    d: "M111 133h78l26 20H85z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5C0C0",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "m111.34 134-23.4 18h124.12l-23.4-18zm77.66-1h-78l-26 20h130z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-custom-docker_svg__a",
    x1: 294.231,
    x2: 5.769,
    y1: 27.002,
    y2: 27.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#F1C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-custom-docker_svg__b",
    x1: 194,
    x2: 194,
    y1: 75,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-custom-docker_svg__c",
    x1: 150,
    x2: 150,
    y1: 133,
    y2: 153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0"
  })))));
};
export { SvgIllustrationCustomDocker as ReactComponent };
export default "data:image/svg+xml;base64,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";